module.exports = __webpack_public_path__ + "static/img/forge-interior.2ff637d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spirit-farm/buildings/forge-interior.jpg
// module id = pAyx
// module chunks = 3